import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { components1lybon96zje1u as components } from './getComponents.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  single3ds7xj9roxi5z as single,
  plus20p0vtfmu0596 as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstancemf79zpjlrrjp as Companion_getInstance } from '../webAuthN.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { WebAuthNProofComponent1mqorb4klgfjg as WebAuthNProofComponent } from './WebAuthNProofComponent.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toDouble_impl_a56y2b33i3iqk8qiaoq as Duration__toDouble_impl_a56y2b,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_DAYS_getInstance3he068lsy3pdd as DurationUnit_DAYS_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LightningServerAuthentication1flu9knqaq6fy as LightningServerAuthentication } from '../../lightningserver/auth/authInterfaces.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { LogInRequest2g40z29mrhnaf as LogInRequest } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/sessionModels.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { plusypd30qeai057 as plus_0 } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
  Companion_getInstance1toimxkidoujm as Companion_getInstance_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ErrorSemantic_getInstance1asme2of31cag as ErrorSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { ProgressBarl6xlv6j3g2vi as ProgressBar } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ProgressBar.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { exceptionMessage1cx0ho62128p8 as exceptionMessage } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementContext.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from './EmailProofComponent.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { forEachAnimated2cqhhdwgrq6qu as forEachAnimated } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/foreach.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  isCharSequence1ju9jr1w86plq as isCharSequence,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toEmailAddress1e4w5ykg7qyos as toEmailAddress,
  toPhoneNumber2boyry1jrtl94 as toPhoneNumber,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { set_padding5v7ifiir6y9y as set_padding } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/Element.ext.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  text189ciz0cnr32o as text,
  h52wvgssab93if0 as h5,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { $serializer_getInstance145ogcrpmqrjd as $serializer_getInstance } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/proofModels.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_emailRegex() {
  _init_properties_authComponent_kt__nnh1ul();
  return emailRegex;
}
var emailRegex;
function get_phoneRegex() {
  _init_properties_authComponent_kt__nnh1ul();
  return phoneRegex;
}
var phoneRegex;
function AuthComponent$_init_$slambda_yjk5vt() {
  return constructCallableReference((_unused_var__etf5q3, it, $completion) => orPromise($completion, function *($completion) {
    return it;
  }), 2);
}
function AuthComponent$authResult$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.proofs_1;
    // Inline function 'kotlin.also' call
    var this_1 = yield* await_0(this_0, $completion);
    if (this_1.isEmpty_y1axqb_k$())
      return null;
    return yield* this$0.subject_1.checkProofs_qk2dxf_k$(this_1, $completion);
  }), 1);
}
function AuthComponent$proofOptions$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.primaryIdentifier_1;
    var primaryIdentifier = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.authResult_1;
    var result = yield* await_1(this_1, $completion);
    var tmp0 = this$0.proofs_1.get_value_j01efc_k$();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$3 = item.via_1;
      destination.add_utx5q5_k$(tmp$ret$3);
    }
    var solved = destination;
    var tmp1_safe_receiver = result == null ? null : result.options_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
      var _iterator__ex2g4s_0 = tmp1_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp$ret$6 = item_0.method_1.via_1;
        destination_0.add_utx5q5_k$(tmp$ret$6);
      }
      tmp = destination_0;
    }
    var available = tmp;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = components(this$0.endpoints_1, this$0.subjectType_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s_1.next_20eer_k$();
      if (!solved.contains_aljjnj_k$(element.get_via_18itzv_k$())) {
        destination_1.add_utx5q5_k$(element);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_2 = destination_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
      if (yield* element_0.supported_g7dhny_k$($completion)) {
        destination_2.add_utx5q5_k$(element_0);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_3 = destination_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var element_1 = _iterator__ex2g4s_3.next_20eer_k$();
      if (primaryIdentifier == null ? !element_1.get_primaryIdentifierRequired_12mtun_k$() : this$0.proofs_1.get_value_j01efc_k$().isEmpty_y1axqb_k$() ? (element_1.get_property_msvula_k$() == null || element_1.get_property_msvula_k$() === primaryIdentifier.property_1) && (this$0.supportUsernames_1 || !(primaryIdentifier.property_1 === 'username')) : true) {
        destination_3.add_utx5q5_k$(element_1);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_4 = destination_3.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
      var element_2 = _iterator__ex2g4s_4.next_20eer_k$();
      if (available == null || available.contains_aljjnj_k$(element_2.get_via_18itzv_k$())) {
        destination_4.add_utx5q5_k$(element_2);
      }
    }
    // Inline function 'kotlin.let' call
    return yield* $(this$0.filterMethods_1(primaryIdentifier, destination_4, $completion), $completion);
  }), 1);
}
function AuthComponent$selectFirstAction$slambda(this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (this$0.currentProof_1.get_value_j01efc_k$() == null) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = this$0.proofOptions_1;
      var tmp$ret$0 = yield* await_1(this_0, $completion);
      var tmp0_safe_receiver = firstOrNull(tmp$ret$0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this$0.currentProof_1.set_value_v1vabv_k$(tmp0_safe_receiver);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
function ProgressBar$_get_ratio_$ref_srdtl5(p0) {
  return constructCallableReference(() => p0.get_ratio_ixudpe_k$(), 0, 0, 158, VOID, [p0]);
}
function ProgressBar$_set_ratio_$ref_cyvrzf(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_ratio_1brdoa_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 159, VOID, [p0]);
}
function AuthComponent$renderPrimaryIdentifier$slambda() {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    return yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().autofillAvailable_8yoauv_k$($completion);
  }), 1);
}
function TextInput$_get_keyboardHints_$ref_2mdqfo(p0) {
  return constructCallableReference(() => p0.keyboardHints_1, 0, 0, 160, VOID, [p0]);
}
function TextInput$_set_keyboardHints_$ref_oc6mq0(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_keyboardHints_w6k1he_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 161, VOID, [p0]);
}
function AuthComponent$renderPrimaryIdentifier$slambda_0(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    var tmp0_safe_receiver = this$0.primaryIdentifier_1.get_value_j01efc_k$();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.property_1;
    if ((tmp1_safe_receiver == null ? null : contains(tmp1_safe_receiver, '_id')) === true) {
      this$0.primaryIdentifier_1.set_value_v1vabv_k$(null);
      tmp = Unit_instance;
    }
    this$0.currentProof_1.set_value_v1vabv_k$(null);
    this$0.proofs_1.set_value_v1vabv_k$(emptyList());
    return Unit_instance;
  }), 0);
}
function AuthComponent$renderPrimaryIdentifier$slambda_1() {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    return yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().webAuthNAvailable_bdf5dj_k$($completion);
  }), 1);
}
function AuthComponent$renderPrimaryIdentifier$slambda_2(this$0, $webAuthn) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.currentProof_1.set_value_v1vabv_k$(new (WebAuthNProofComponent())($webAuthn, single(this$0.endpoints_1.subjects_1.get_keys_wop4xp_k$()), false));
    return Unit_instance;
  }), 0);
}
function AuthComponent$renderFinalize$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = this$0.endpoints_1.knownDeviceProof_1;
    return tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver.knownDeviceOptions_ut629v_k$($completion));
  }), 1);
}
function AuthComponent$renderFinalize$lambda(it) {
  // Inline function 'kotlin.time.Companion.days' call
  Companion_getInstance_0();
  var tmp$ret$0 = toDuration(1, DurationUnit_DAYS_getInstance());
  return !equals(it, new (Duration())(tmp$ret$0));
}
function AuthComponent$renderFinalize$lambda_0(it) {
  var tmp;
  if (it) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.days' call
    Companion_getInstance_0();
    tmp = toDuration(1, DurationUnit_DAYS_getInstance());
  }
  var tmp_0 = tmp;
  return tmp_0 == null ? null : new (Duration())(tmp_0);
}
function AuthComponent$renderFinalize$slambda$slambda($rememberDevice, this$0, $it, $knownDevice) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    if (yield* await_0($rememberDevice, $completion)) {
      var tmp0_safe_receiver = this$0.endpoints_1.withAuth_n8dse1_k$(new (LightningServerAuthentication())(this$0.subject_1, this$0.subjectType_1, $it)).knownDeviceProof_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver.establishKnownDeviceV2_gsx0du_k$($completion));
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_0 = $knownDevice;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          var tmp1_safe_receiver_0 = this$0.primaryIdentifier_1.get_value_j01efc_k$();
          var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.value_1;
          tmp0_safe_receiver_0.set_value_v1vabv_k$(new (KnownDeviceSecretInfoStuff())(tmp1_safe_receiver, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs));
        }
      }
    } else {
      var tmp2_safe_receiver = $knownDevice;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.set_value_v1vabv_k$(null);
      }
    }
    return Unit_instance;
  }), 1);
}
function AuthComponent$renderFinalize$slambda_0(this$0, $desiredSessionLength, $rememberDevice, $knownDevice) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.proofs_1;
    var tmp = yield* await_0(this_0, $completion);
    var tmp_0 = yield* await_0($desiredSessionLength, $completion);
    var tmp0_safe_receiver = tmp_0 == null ? null : tmp_0.rawValue_1;
    var tmp_1;
    var tmp_2 = tmp0_safe_receiver;
    if ((tmp_2 == null ? null : new (Duration())(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      var tmp_3 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_3 == null ? null : new (Duration())(tmp_3)).rawValue_1;
      tmp_1 = System_instance.now_2cba_k$().plus_tegsqz_k$(it);
    }
    var result = yield* this$0.subject_1.logInV2_lw4xp7_k$(new (LogInRequest())(tmp, VOID, VOID, tmp_1), $completion);
    var tmp1_safe_receiver = result.refreshToken_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* $(this$0.onAuthentication_1(tmp1_safe_receiver, $completion), $completion);
      var tmp_4 = plus_0(get_AppScope(), Dispatchers_getInstance().get_Main_wo5vz6_k$());
      launch(tmp_4, VOID, VOID, AuthComponent$renderFinalize$slambda$slambda($rememberDevice, this$0, tmp1_safe_receiver, $knownDevice));
    }
    return Unit_instance;
  }), 0);
}
function AuthComponent$pickProof$slambda$slambda($task, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = yield* $($task($completion), $completion);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var _receiver__tnumb7 = this$0.proofs_1;
      _receiver__tnumb7.set_value_v1vabv_k$(plus(_receiver__tnumb7.get_value_j01efc_k$(), tmp0_safe_receiver));
    }
    return Unit_instance;
  }), 1);
}
function AuthComponent$pickProof$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.proofOptions_1;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = yield* await_1(this_0, $completion);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp0_safe_receiver = element.get_earlyProof_n45gpi_k$();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = launch($this$launch, VOID, VOID, AuthComponent$pickProof$slambda$slambda(tmp0_safe_receiver, this$0));
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver_0);
      }
    }
    return Unit_instance;
  }), 1);
}
function AuthComponent$pickProof$lambda$slambda($cancelIfSelected, this$0, $it) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $cancelIfSelected.cancel$default_8haxne_k$();
    this$0.currentProof_1.set_value_v1vabv_k$($it);
    return Unit_instance;
  }), 0);
}
var AuthComponentClass;
function AuthComponent() {
  if (AuthComponentClass === VOID) {
    class $ {
      constructor(endpoints, subjectType, subject, supportUsernames, knownDeviceLocalStorageName, filterMethods, onAuthentication) {
        subjectType = subjectType === VOID ? single(endpoints.subjects_1.get_keys_wop4xp_k$()) : subjectType;
        subject = subject === VOID ? ensureNotNull(endpoints.subjects_1.get_wei43m_k$(subjectType)) : subject;
        supportUsernames = supportUsernames === VOID ? false : supportUsernames;
        knownDeviceLocalStorageName = knownDeviceLocalStorageName === VOID ? 'known-device' : knownDeviceLocalStorageName;
        var tmp;
        if (filterMethods === VOID) {
          tmp = AuthComponent$_init_$slambda_yjk5vt();
        } else {
          tmp = filterMethods;
        }
        filterMethods = tmp;
        this.endpoints_1 = endpoints;
        this.subjectType_1 = subjectType;
        this.subject_1 = subject;
        this.supportUsernames_1 = supportUsernames;
        this.knownDeviceLocalStorageName_1 = knownDeviceLocalStorageName;
        this.filterMethods_1 = filterMethods;
        this.onAuthentication_1 = onAuthentication;
        this.primaryIdentifier_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.rawPrimaryInput_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp_0 = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_0.proofs_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        this.currentProof_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        var tmp_1 = this;
        tmp_1.authResult_1 = rememberSuspending(VOID, VOID, VOID, AuthComponent$authResult$slambda(this));
        var tmp_2 = this;
        tmp_2.proofOptions_1 = rememberSuspending(VOID, VOID, VOID, AuthComponent$proofOptions$slambda(this));
        var tmp_3 = this;
        var tmp_4 = Companion_getInstance_1().done_1;
        tmp_3.selectFirstAction_1 = Action('Select First', tmp_4, VOID, VOID, VOID, VOID, AuthComponent$selectFirstAction$slambda(this));
      }
      render_8j8w82_k$(to_0) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(to_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        to_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        this.renderPrimaryIdentifier_liv3m9_k$(element);
        var progress = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(this.authResult_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.sumOf' call
            var sum = 0;
            var _iterator__ex2g4s = $this$remember.invoke_r7m7el_k$(this.proofs_1).iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var tmp_0 = sum;
              sum = tmp_0 + element.strength_1 | 0;
            }
            tmp = sum / tmp0_safe_receiver.strengthRequired_1;
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
        });
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var this_0 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          var containsArg = $this$shownWhen.invoke_r7m7el_k$(progress);
          return 0.01 <= containsArg ? containsArg <= 0.99 : false;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.progressBar' call
        var this_1 = themed(this_0, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (ProgressBar())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        var tmp = KMutableProperty0();
        var tmp_0 = ProgressBar$_get_ratio_$ref_srdtl5(element_0);
        var tmp_1 = getPropertyCallableRef('ratio', 0, tmp, tmp_0, ProgressBar$_set_ratio_$ref_cyvrzf(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(progress));
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_2 = get_centered(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        var this_2 = shownWhen(tmp_2, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$shownWhen.state_a9mnra_k$(this.authResult_1);
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp = false;
          }
          return !tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (ActivityIndicator())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_3 = themed(shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var this_0 = $this$shownWhen.state_a9mnra_k$(this.authResult_1);
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp0_safe_receiver = tmp instanceof InternalReactiveThrownException() ? tmp : null;
          return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.exception_1) == null);
        }), ErrorSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        var $this$col = element_2;
        var msg = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var this_0 = $this$remember.state_a9mnra_k$(this.authResult_1);
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp0_safe_receiver = tmp instanceof InternalReactiveThrownException() ? tmp : null;
          var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.exception_1;
          var tmp_0;
          if (tmp0_safe_receiver_0 == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = exceptionMessage($this$col.get_context_h02k06_k$(), tmp0_safe_receiver_0);
          }
          return tmp_0;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())($this$col.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        $this$col.willAddChild_hz2iwc_k$(element_3);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(msg);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.title_1;
          return tmp1_elvis_lhs == null ? 'Error' : tmp1_elvis_lhs;
        });
        element_3.onStartup_vrxh3i_k$();
        $this$col.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())($this$col.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        $this$col.willAddChild_hz2iwc_k$(element_4);
        element_4.set_themeChoice_py59um_k$(element_4.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_6 = KMutableProperty0();
        var tmp_7 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_8 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_8, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(msg);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.body_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        element_4.onStartup_vrxh3i_k$();
        $this$col.addChild_2qpft2_k$(element_4);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        this.pickProof_v0vojh_k$(shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          var tmp;
          var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(this.authResult_1);
          if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.readyToLogIn_1) === true)) {
            tmp = $this$shownWhen.invoke_r7m7el_k$(this.currentProof_1) == null;
          } else {
            tmp = false;
          }
          return tmp;
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.currentProof_1) == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_4.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(true);
        var tmp_9 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = listOfNotNull($this$remember.invoke_r7m7el_k$(this.currentProof_1));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$39 = to(item, $this$remember.invoke_r7m7el_k$(this.authResult_1));
            destination.add_utx5q5_k$(tmp$ret$39);
          }
          return destination;
        });
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp$ret$40 = toDuration(10, DurationUnit_MILLISECONDS_getInstance());
        var tmp_10 = element_5.debounce_kh28nr_k$(tmp_9, tmp$ret$40);
        forEachAnimated(element_5, tmp_10, VOID, ($this$forEachAnimated, _destruct__k2r9zo) => {
          var it = _destruct__k2r9zo.component1_7eebsc_k$();
          var authResult = _destruct__k2r9zo.component2_7eebsb_k$();
          var tmp = this.primaryIdentifier_1.get_value_j01efc_k$();
          var tmp_0 = this.proofs_1.get_value_j01efc_k$();
          it.render_7hnxhp_k$($this$forEachAnimated, tmp, authResult, tmp_0, (it) => {
            var tmp;
            if (!(it == null)) {
              var _receiver__tnumb7 = this.proofs_1;
              _receiver__tnumb7.set_value_v1vabv_k$(plus(_receiver__tnumb7.get_value_j01efc_k$(), it));
              var tmp_0;
              if (this.primaryIdentifier_1.get_value_j01efc_k$() == null) {
                this.primaryIdentifier_1.set_value_v1vabv_k$(new (UserIdentification())(it.property_1, it.value_1));
                tmp_0 = Unit_instance;
              }
              tmp = tmp_0;
            }
            this.currentProof_1.set_value_v1vabv_k$(null);
            return Unit_instance;
          });
          return Unit_instance;
        });
        element_5.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_5);
        this.renderFinalize_aj2sq6_k$(shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(this.authResult_1);
          return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.readyToLogIn_1) === true;
        }));
        element.onStartup_vrxh3i_k$();
        to_0.addChild_2qpft2_k$(element);
      }
      renderPrimaryIdentifier_liv3m9_k$(to) {
        // Inline function 'kotlin.with' call
        var tmp0 = shownWhen(to, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.proofs_1).isEmpty_y1axqb_k$() && $this$shownWhen.invoke_r7m7el_k$(this.currentProof_1) == null);
        // Inline function 'com.lightningkite.kiteui.views.l2.field' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = !(this.endpoints_1.emailProof_1 == null) && !(this.endpoints_1.smsProof_1 == null) ? 'Email or Phone Number' : !(this.endpoints_1.emailProof_1 == null) ? 'Email' : !(this.endpoints_1.smsProof_1 == null) ? 'Phone Number' : 'Username';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        tmp0.willAddChild_hz2iwc_k$(element);
        element.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var $this$field = themed(element, FieldSemantic_getInstance());
        var autoFillAvailable = rememberSuspending(VOID, VOID, VOID, AuthComponent$renderPrimaryIdentifier$slambda());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextInput())($this$field.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        $this$field.willAddChild_hz2iwc_k$(element_0);
        var $this$textInput = element_0;
        $this$textInput.set_debugName_wihv62_k$('primaryInput');
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = !(this.endpoints_1.emailProof_1 == null) && !(this.endpoints_1.smsProof_1 == null) ? 'me@email.com OR 800-123-4567' : !(this.endpoints_1.emailProof_1 == null) ? 'me@email.com' : !(this.endpoints_1.smsProof_1 == null) ? '800-123-4567' : 'MyUsername';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        $this$textInput.native_1.attributes_1.native_1.placeholder = value;
        var tmp = KMutableProperty0();
        var tmp_0 = TextInput$_get_keyboardHints_$ref_2mdqfo($this$textInput);
        var tmp_1 = getPropertyCallableRef('keyboardHints', 0, tmp, tmp_0, TextInput$_set_keyboardHints_$ref_oc6mq0($this$textInput));
        $this$textInput.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'kotlin.let' call
          var it = !(this.endpoints_1.emailProof_1 == null) && !(this.endpoints_1.smsProof_1 == null) ? Companion_getInstance_2().email_1 : !(this.endpoints_1.emailProof_1 == null) ? Companion_getInstance_2().email_1 : !(this.endpoints_1.smsProof_1 == null) ? Companion_getInstance_2().phone_1 : Companion_getInstance_2().id_1;
          return !(this.endpoints_1.webAuthNProof_1 == null) && $this$invoke.invoke_r7m7el_k$(autoFillAvailable) ? it.copy$default_zb1eab_k$(VOID, VOID, VOID, true) : it;
        });
        $this$textInput.bind_gesskf_k$($this$textInput.content_1, this.rawPrimaryInput_1);
        reactive($this$textInput, VOID, ($this$reactive) => {
          var p = $this$reactive.invoke_r7m7el_k$(this.primaryIdentifier_1);
          var tmp;
          var tmp3_safe_receiver = p == null ? null : p.property_1;
          if (!((tmp3_safe_receiver == null ? null : contains(tmp3_safe_receiver, '_id')) === true)) {
            var tmp1_elvis_lhs = p == null ? null : p.value_1;
            this.rawPrimaryInput_1.set_value_v1vabv_k$(tmp1_elvis_lhs == null ? this.rawPrimaryInput_1.get_value_j01efc_k$() : tmp1_elvis_lhs);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        reactive($this$textInput, VOID, ($this$reactive) => {
          var it = $this$reactive.invoke_r7m7el_k$(this.rawPrimaryInput_1);
          var tmp;
          var tmp0_safe_receiver = this.primaryIdentifier_1.get_value_j01efc_k$();
          if (it === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value_1)) {
            return Unit_instance;
          }
          // Inline function 'kotlin.run' call
          var tmp$ret$18;
          $l$block: {
            if (isBlank(it)) {
              tmp$ret$18 = null;
              break $l$block;
            }
            var tmp_0;
            try {
              var tmp_1;
              if (get_emailRegex().matches_evli6i_k$(it)) {
                // Inline function 'kotlin.text.trim' call
                var tmp$ret$19 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
                toEmailAddress(tmp$ret$19);
                // Inline function 'kotlin.text.trim' call
                var tmp$ret$20 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
                tmp_1 = new (UserIdentification())('email', tmp$ret$20);
              } else {
                tmp_1 = null;
              }
              tmp_0 = tmp_1;
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Exception()) {
                var _unused_var__etf5q3 = $p;
                tmp_2 = null;
              } else {
                throw $p;
              }
              tmp_0 = tmp_2;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              var tmp_4;
              try {
                var tmp_5;
                if (get_phoneRegex().matches_evli6i_k$(it)) {
                  // Inline function 'kotlin.text.trim' call
                  var tmp$ret$21 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
                  toPhoneNumber(tmp$ret$21);
                  // Inline function 'kotlin.text.trim' call
                  var tmp$ret$22 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
                  tmp_5 = new (UserIdentification())('phone', tmp$ret$22);
                } else {
                  tmp_5 = null;
                }
                tmp_4 = tmp_5;
              } catch ($p_0) {
                var tmp_6;
                if ($p_0 instanceof Exception()) {
                  var e = $p_0;
                  printStackTrace2(e);
                  tmp_6 = null;
                } else {
                  throw $p_0;
                }
                tmp_4 = tmp_6;
              }
              tmp_3 = tmp_4;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }
            var tmp1_elvis_lhs = tmp_3;
            var tmp_7;
            if (tmp1_elvis_lhs == null) {
              var tmp_8;
              if (this.supportUsernames_1) {
                // Inline function 'kotlin.text.trim' call
                var tmp$ret$23 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
                tmp_8 = new (UserIdentification())('username', tmp$ret$23);
              } else {
                tmp_8 = null;
              }
              tmp_7 = tmp_8;
            } else {
              tmp_7 = tmp1_elvis_lhs;
            }
            tmp$ret$18 = tmp_7;
          }
          var tmp$ret$17 = tmp$ret$18;
          this.primaryIdentifier_1.set_value_v1vabv_k$(tmp$ret$17);
          return Unit_instance;
        });
        reactive($this$textInput, VOID, ($this$reactive) => {
          var tmp;
          if ($this$reactive.invoke_r7m7el_k$(this.currentProof_1) == null) {
            $this$textInput.requestFocus_9180nb_k$();
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          $this$textInput.set_action_2ds022_k$(this.selectFirstAction_1);
        }
        element_0.onStartup_vrxh3i_k$();
        $this$field.addChild_2qpft2_k$(element_0);
        errorText(element);
        element.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_0 = shownWhen(to, VOID, VOID, ($this$shownWhen) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$shownWhen.invoke_r7m7el_k$(this.proofs_1).isEmpty_y1axqb_k$()) {
            tmp = true;
          } else {
            tmp = !($this$shownWhen.invoke_r7m7el_k$(this.currentProof_1) == null);
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_0.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_1 = get_centered(element_1);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_1.willAddChild_hz2iwc_k$(element_2);
        element_2.set_debugName_wihv62_k$('cancelButton');
        set_padding(element_2, get_rem(0.2));
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var icon = Companion_getInstance_1().arrowBack_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (IconView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_source_3o5lkf_k$(icon);
        element_3.set_description_s1386w_k$('Cancel');
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        onClick(element_2, VOID, VOID, VOID, AuthComponent$renderPrimaryIdentifier$slambda_0(this));
        element_2.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_3.willAddChild_hz2iwc_k$(element_4);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.primaryIdentifier_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_0;
            if (!contains(tmp0_safe_receiver.property_1, '_id')) {
              tmp_0 = tmp0_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          var tmp1_safe_receiver = tmp;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.value_1;
          return tmp2_elvis_lhs == null ? 'Using Passkey' : tmp2_elvis_lhs;
        });
        element_4.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_4);
        element_1.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_1);
        var tmp0_safe_receiver = this.endpoints_1.webAuthNProof_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (this.endpoints_1.webAuthNIncludePasskeyUI_1) {
            var webAuthAvailable = rememberSuspending(VOID, VOID, VOID, AuthComponent$renderPrimaryIdentifier$slambda_1());
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            var this_4 = shownWhen(to, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.primaryIdentifier_1) == null && $this$shownWhen.invoke_r7m7el_k$(this.currentProof_1) == null && $this$shownWhen.invoke_r7m7el_k$(this.proofs_1).isEmpty_y1axqb_k$() && $this$shownWhen.invoke_r7m7el_k$(webAuthAvailable));
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
            ensureOutermostElement(element_5);
            this_4.willAddChild_hz2iwc_k$(element_5);
            element_5.set_vertical_nuap32_k$(true);
            text(get_centered(element_5), 'Or');
            // Inline function 'com.lightningkite.kiteui.views.card' call
            // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
            var this_5 = themed(element_5, CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            var this_6 = themed(this_5, ButtonSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_6 = new (Button())(this_6.get_context_h02k06_k$());
            ensureOutermostElement(element_6);
            this_6.willAddChild_hz2iwc_k$(element_6);
            element_6.set_debugName_wihv62_k$('usePasskeyButton');
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            var this_7 = sizeConstraints(get_centered(element_6), VOID, VOID, VOID, VOID, VOID, get_rem_0(16));
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_7 = new (Frame())(this_7.get_context_h02k06_k$());
            ensureOutermostElement(element_7);
            this_7.willAddChild_hz2iwc_k$(element_7);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            var this_8 = get_centered(element_7);
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_8 = new (RowOrCol())(this_8.get_context_h02k06_k$());
            ensureOutermostElement(element_8);
            this_8.willAddChild_hz2iwc_k$(element_8);
            element_8.set_vertical_nuap32_k$(false);
            var tmp0_0 = get_centered(element_8);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon_0 = Companion_getInstance_1().passkey_1;
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_9 = new (IconView())(tmp0_0.get_context_h02k06_k$());
            ensureOutermostElement(element_9);
            tmp0_0.willAddChild_hz2iwc_k$(element_9);
            element_9.set_source_3o5lkf_k$(icon_0);
            element_9.set_description_s1386w_k$('');
            element_9.onStartup_vrxh3i_k$();
            tmp0_0.addChild_2qpft2_k$(element_9);
            text(get_centered(element_8), 'Use Passkey');
            element_8.onStartup_vrxh3i_k$();
            this_8.addChild_2qpft2_k$(element_8);
            element_7.onStartup_vrxh3i_k$();
            this_7.addChild_2qpft2_k$(element_7);
            onClick(element_6, VOID, VOID, VOID, AuthComponent$renderPrimaryIdentifier$slambda_2(this, tmp0_safe_receiver));
            element_6.onStartup_vrxh3i_k$();
            this_6.addChild_2qpft2_k$(element_6);
            element_5.onStartup_vrxh3i_k$();
            this_4.addChild_2qpft2_k$(element_5);
          }
        }
        return Unit_instance;
      }
      renderFinalize_aj2sq6_k$(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        // Inline function 'kotlin.time.Companion.days' call
        Companion_getInstance_0();
        var tmp$ret$4 = toDuration(1, DurationUnit_DAYS_getInstance());
        var desiredSessionLength = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (Duration())(tmp$ret$4));
        var rememberDevice = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
        var tmp0_safe_receiver = this.knownDeviceLocalStorageName_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
          // Inline function 'kotlinx.serialization.serializer' call
          // Inline function 'kotlinx.serialization.internal.cast' call
          var this_0 = serializer(createKType(getKClass(KnownDeviceSecretInfoStuff()), arrayOf([]), true));
          var tmp$ret$8 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
          tmp = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(tmp0_safe_receiver, null, tmp$ret$8);
        }
        var knownDevice = tmp;
        var knownDeviceOptions = rememberSuspending(VOID, VOID, VOID, AuthComponent$renderFinalize$slambda(this));
        h5(get_centered(element), 'Ready to login');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(knownDeviceOptions) == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Checkbox())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_debugName_wihv62_k$('rememberDeviceCheckbox');
        element_1.bind_gesskf_k$(element_1.checked_1, rememberDevice);
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'This is my device';
        var tmp_0 = element_2.native_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = value;
        }
        tmp_0.set_content_i5lrjv_k$(tmp_1);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(rememberDevice) || $this$shownWhen.invoke_r7m7el_k$(knownDeviceOptions) == null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_4.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        var this_5 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Checkbox())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        element_4.set_debugName_wihv62_k$('keepLoggedInCheckbox');
        var tmp_2 = AuthComponent$renderFinalize$lambda;
        element_4.bind_gesskf_k$(element_4.checked_1, desiredSessionLength.lens_drj4fu_k$(tmp_2, AuthComponent$renderFinalize$lambda_0));
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_6 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.authResult_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.maxExpiration_1;
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = tmp1_safe_receiver.minus_bn4aoq_k$(System_instance.now_2cba_k$());
          }
          var tmp2_safe_receiver = tmp;
          var tmp_0;
          var tmp_1 = tmp2_safe_receiver;
          if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
            tmp_0 = null;
          } else {
            tmp_0 = Duration__toDouble_impl_a56y2b(tmp2_safe_receiver, DurationUnit_DAYS_getInstance());
          }
          var tmp3_safe_receiver = tmp_0;
          var days = tmp3_safe_receiver == null ? null : roundToInt(tmp3_safe_receiver);
          return !(days == null) ? 'Keep me logged in for ' + days + ' days' : 'Keep me logged in';
        });
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        element_3.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_7 = themed(element, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_8 = themed(this_7, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Button())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_8.willAddChild_hz2iwc_k$(element_6);
        element_6.set_debugName_wihv62_k$('loginButton');
        text(get_centered(element_6), 'Login');
        onClick(element_6, VOID, VOID, VOID, AuthComponent$renderFinalize$slambda_0(this, desiredSessionLength, rememberDevice, knownDevice));
        element_6.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_6);
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      pickProof_v0vojh_k$(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        var cancelIfSelected = launch(element, VOID, VOID, AuthComponent$pickProof$slambda(this));
        forEachAnimated(element, this.proofOptions_1, VOID, ($this$forEachAnimated, it) => {
          // Inline function 'com.lightningkite.kiteui.views.card' call
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var this_0 = themed($this$forEachAnimated, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_1 = themed(this_0, ButtonSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Button())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_1.willAddChild_hz2iwc_k$(element);
          element.set_debugName_wihv62_k$(it.name_vv06me_k$(true));
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_2 = sizeConstraints(get_centered(element), VOID, VOID, VOID, VOID, VOID, get_rem_0(16));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Frame())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_3 = get_centered(element_0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(false);
          var tmp0 = get_centered(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = it.get_icon_wont8i_k$();
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          tmp0.willAddChild_hz2iwc_k$(element_2);
          element_2.set_source_3o5lkf_k$(icon);
          element_2.set_description_s1386w_k$('');
          element_2.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_4 = get_centered(element_1);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (TextView())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          this_4.willAddChild_hz2iwc_k$(element_3);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_3);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_3));
          element_3.invoke_bnq13k_k$(tmp_1, ($this$invoke) => it.name_vv06me_k$($this$invoke.invoke_r7m7el_k$(this.proofs_1).isEmpty_y1axqb_k$()));
          element_3.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_3);
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          onClick(element, VOID, VOID, VOID, AuthComponent$pickProof$lambda$slambda(cancelIfSelected, this, it));
          element.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'AuthComponent');
    AuthComponentClass = $;
  }
  return AuthComponentClass;
}
var UserIdentificationClass;
function UserIdentification() {
  if (UserIdentificationClass === VOID) {
    class $ {
      constructor(property, value) {
        this.property_1 = property;
        this.value_1 = value;
      }
      toString() {
        return 'UserIdentification(property=' + this.property_1 + ', value=' + this.value_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.property_1);
        result = imul(result, 31) + getStringHashCode(this.value_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UserIdentification()))
          return false;
        if (!(this.property_1 === other.property_1))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'UserIdentification');
    UserIdentificationClass = $;
  }
  return UserIdentificationClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.auth.KnownDeviceSecretInfoStuff', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('info', false);
        tmp0_serialDesc.addElement_5pzumi_k$('primaryIdentifier', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_30nxk5_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance(), value.info_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.primaryIdentifier_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_30nxk5_k$(encoder, value instanceof KnownDeviceSecretInfoStuff() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return KnownDeviceSecretInfoStuff().new_com_lightningkite_kiteui_auth_KnownDeviceSecretInfoStuff_esmz03_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var KnownDeviceSecretInfoStuffClass;
function KnownDeviceSecretInfoStuff() {
  if (KnownDeviceSecretInfoStuffClass === VOID) {
    class $ {
      constructor(info, primaryIdentifier) {
        this.info_1 = info;
        this.primaryIdentifier_1 = primaryIdentifier;
      }
      toString() {
        return 'KnownDeviceSecretInfoStuff(info=' + this.info_1.toString() + ', primaryIdentifier=' + this.primaryIdentifier_1 + ')';
      }
      hashCode() {
        var result = this.info_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.primaryIdentifier_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceSecretInfoStuff()))
          return false;
        if (!this.info_1.equals(other.info_1))
          return false;
        if (!(this.primaryIdentifier_1 === other.primaryIdentifier_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_auth_KnownDeviceSecretInfoStuff_esmz03_k$(seen0, info, primaryIdentifier, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.info_1 = info;
        $this.primaryIdentifier_1 = primaryIdentifier;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceSecretInfoStuff', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    KnownDeviceSecretInfoStuffClass = $;
  }
  return KnownDeviceSecretInfoStuffClass;
}
var properties_initialized_authComponent_kt_shw3hh;
function _init_properties_authComponent_kt__nnh1ul() {
  if (!properties_initialized_authComponent_kt_shw3hh) {
    properties_initialized_authComponent_kt_shw3hh = true;
    emailRegex = Regex().new_kotlin_text_Regex_acuq4a_k$('[\\w\\-+._]+@(?:[\\w\\-]+\\w\\.)+[\\w\\-]+\\w$');
    phoneRegex = Regex().new_kotlin_text_Regex_acuq4a_k$('\\+?(?:[0-9][-. ]?){6,}[0-9]$');
  }
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  AuthComponent as AuthComponenthdtropyf0pe3,
};
//endregion

//# sourceMappingURL=authComponent.mjs.map
